module.exports = __webpack_public_path__ + "img/notification.928188f7.png";